exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#character-preview{margin-bottom:2rem}.preview__abilities{display:flex;justify-content:space-between;flex-wrap:wrap}@media only screen and (max-width:991px){.preview__abilities{justify-content:flex-start}}.preview__abilities .preview__ability{padding:.25rem}@media only screen and (min-width:992px){.preview__abilities .preview__ability{width:47%}}.preview__abilities .preview__ability strong{text-transform:capitalize}.preview__racial-trait:hover{background:var(--secondary-color-light);font-weight:700}@media only screen and (max-width:991px){.hidden-md-down{display:none}}@media only screen and (min-width:992px){.hidden-lg-up{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-968e4d62","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CharacterPreview.vue
// module id = 30
// module chunks = 0